import {
  SellHeader,
  SellSearch,
  SellLandingHighlight
} from "components/UI/molecules";
import { SellTestimonials } from "components/UI/organisms";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import { INTERNAL_PATHS } from "routes/paths";

export const SellGiftCards = () => {
  return (
    <div className="sell-gift-cards">
      <ReactHelmetWithProvider>
        <meta
          name="description"
          content="Turn unused gift cards into instant cash with GCX. Get fast, secure payouts with no hidden fees when you sell your cards online today."
        />
        <title>
          Sell Gift Cards Online - Instant Cash, Fast & Trusted | GCX
        </title>
        <link
          rel="canonical"
          href={window.location.origin + INTERNAL_PATHS.SELL_GIFT_CARDS}
        />
      </ReactHelmetWithProvider>
      <SellHeader />
      <SellSearch />
      <SellLandingHighlight />
      <SellTestimonials />
    </div>
  );
};
